import React from 'react'
import { FranchiseTableDisplay } from '../pages/Application/ConfirmSpongeCF'

const TermsPopup4CF = ({ termsPopupClose, capture, franchiseName }) => {
  return (
    <div className="TermsPopup forCF">
      <div id="terms_st" className={capture ? 'capture_terms_popup' : 'terms_popup forCF'}>
        {!capture && (
          <div className="terms_popup_header">
            <div className="btn_close" onClick={termsPopupClose}></div>
          </div>
        )}
        <div className="terms_popup_contents">
          <p className="terms_popup_tit">프랜차이즈 정보 제공 동의</p>

          <div
            style={{
              borderBottom: '1.5px solid rgba(224, 224, 224, 1)',
              paddingBottom: '11px',
              paddingTop: '9px',
              marginBottom: '27px'
            }}>
            <p className="color_blue font_nomal" style={{ lineHeight: '24px' }}>
              {/* 신청자 휴대폰번호로 스폰지C 서비스 관련 알림톡이 발송됩니다. */}
              스폰지R 서비스 프랜차이즈 가맹점 신청서에서 약관에 동의하신 내용에 따라 아래와 같이 프랜차이즈에 가맹점 정보를 제공합니다.
            </p>
          </div>
          <FranchiseTableDisplay franchiseName={franchiseName} />
          <div style={{ marginBottom: '27px' }}></div>
          {!capture && (
            <button type="button" className="btn_default" onClick={termsPopupClose}>
              동의 하기
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export { TermsPopup4CF }
